import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionGamma/details/pageContext';

/**
 * @deprecated use usePetitionDetailsPageFcm() instead
 */
export const useFcm = usePetitionDetailsPageFcm;
